export enum AnalyticTargetAxisEnum {
  X = 'x',
  Y = 'y',
  Z = 'z',
}
